module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-4328c5d1.png";